import { useCallback } from 'react';

import { sendMetric } from './metics-sender';

export const useSocializationBrandMetric = () => {
  return useCallback((offerId: string) => {
    sendMetric({ name: 'SOCIALIZATION_BRAND', customData: { offerId } });
  }, []);
};
